import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["step", "indicator", "circle", "line", "prevBtn", "nextBtn", "submitBtn", "spinner", "form"]
  static values = { current: { type: Number, default: 0 } }

  connect() {
    this.totalSteps = this.stepTargets.length
    this.showStep(this.currentValue)
  }

  next() {
    if (this.validateCurrentStep() && this.currentValue < this.totalSteps - 1) {
      this.currentValue++
      this.showStep(this.currentValue)
    }
  }

  prev() {
    if (this.currentValue > 0) {
      this.currentValue--
      this.showStep(this.currentValue)
    }
  }

  showStep(index) {
    // Hide all steps, show current
    this.stepTargets.forEach((step, i) => {
      step.classList.toggle("hidden", i !== index)
    })

    // Update step indicator circles
    this.circleTargets.forEach((circle, i) => {
      if (i <= index) {
        // Completed or current step
        circle.classList.add("bg-primary", "text-white", "border-primary")
        circle.classList.remove("bg-base-100", "text-base-content", "border-base-300")
      } else {
        // Future step
        circle.classList.remove("bg-primary", "text-white", "border-primary")
        circle.classList.add("bg-base-100", "text-base-content", "border-base-300")
      }
    })

    // Update connecting lines (line 0 = between step 1-2, line 1 = between step 2-3)
    this.lineTargets.forEach((line, i) => {
      if (i < index) {
        line.classList.add("bg-primary")
        line.classList.remove("bg-base-300")
      } else {
        line.classList.remove("bg-primary")
        line.classList.add("bg-base-300")
      }
    })

    // Show/hide nav buttons
    this.prevBtnTarget.classList.toggle("invisible", index === 0)
    this.nextBtnTarget.classList.toggle("hidden", index === this.totalSteps - 1)
    this.submitBtnTarget.classList.toggle("hidden", index !== this.totalSteps - 1)
  }

  validateCurrentStep() {
    const currentStepEl = this.stepTargets[this.currentValue]
    const inputs = currentStepEl.querySelectorAll("input[required], select[required]")
    let valid = true

    inputs.forEach(input => {
      if (!input.checkValidity()) {
        input.reportValidity()
        valid = false
      }
    })
    return valid
  }

  showLoading() {
    this.formTarget.classList.add("hidden")
    this.spinnerTarget.classList.remove("hidden")
  }

  hideLoading() {
    this.spinnerTarget.classList.add("hidden")
    this.formTarget.classList.remove("hidden")
  }

  openFullCalculator(event) {
    event.preventDefault()
    const form = this.formTarget
    const params = new URLSearchParams()

    // Collect all form field values
    const fields = ['postal_code', 'city', 'province', 'location_type', 'property_type',
                    'estimated_value', 'owner1_age', 'owner1_gender', 'owner2_age', 'owner2_gender']

    fields.forEach(field => {
      const input = form.querySelector(`[name="calculation[${field}]"]`)
      if (input) {
        // Handle radio buttons
        if (input.type === 'radio') {
          const checked = form.querySelector(`[name="calculation[${field}]"]:checked`)
          if (checked) params.set(`calculation[${field}]`, checked.value)
        } else if (input.value) {
          params.set(`calculation[${field}]`, input.value)
        }
      }
    })

    const baseUrl = event.currentTarget.dataset.wizardUrl || '/calculator'
    window.location.href = `${baseUrl}?${params.toString()}`
  }
}
